import {useContext} from 'react'
import { Payment } from '../Payment/Payment'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import Radio from '../Atoms/Radio';
import Button from '../Atoms/Button';
import BirthdayPicker from '../Atoms/BirthdayPicker';

import { ProductContext } from '../Context/Context'


import './PaymentScreen.sass'
import { useSessionStorage } from '../Hooks/useSessionStorage';



const PaymentScreen = (props) => {

	const {
		bestellung,
		setBestellung,
		step,
		setStep,
} = useContext(ProductContext)




	const [billing, setBilling] = useSessionStorage('no__billing', false)
	const [clientChange, setClientChange] = useSessionStorage('no__birthday', {
		main: {
			required: false,
			date: ''
		}
	})

	const handleClientChange = (key, bool) => {
		if (clientChange[key] && clientChange[key].date) {
			setClientChange(prev => ({
				...prev,
				[key]: {
					...prev[key],
					required: bool
				}
			}))
		} else { 
			setClientChange(prev => ({
				...prev,
				[key]: {
					required: bool,
					date: ''
				}
			}))
		}
	}

	const handleAdditionalBilling = key => { 
		// console.log(key)
		setBestellung(prev =>({
			...prev,
			contact: {
				...prev.contact,
				[key]: {
					...prev.contact[key],
					billing: {
						...prev.contact[key].billing,
						billing: !prev.contact[key].billing.billing}
				}

			}
			
		}))
	}

	const initialValues = {
		email: 					bestellung.contact.main.email || '',
		first: 					bestellung.contact.main.first || '',
		last: 					bestellung.contact.main.last || '',
		street: 				bestellung.contact.main.street || '',
		street_number: 			bestellung.contact.main.street_number || '',
		city: 					bestellung.contact.main.city || '',
		company: 				bestellung.contact.main.company || '',
		phone: 					bestellung.contact.main.phone || '',
		clientId: 				bestellung.contact.main.clientId || '',
		payment: 				bestellung.contact.main.payment.method || '',
		billing: 				bestellung.contact.main.billing ? bestellung.contact.main.billing.billing : '',
		firstbilling: 			bestellung.contact.main.billing ? bestellung.contact.main.billing.first : '',
		lastbilling: 			bestellung.contact.main.billing ? bestellung.contact.main.billing.last : '',
		companybilling: 		bestellung.contact.main.billing ? bestellung.contact.main.billing.company : '',
		streetbilling: 			bestellung.contact.main.billing ? bestellung.contact.main.billing.street : '',
		street_numberbilling: 	bestellung.contact.main.billing ?bestellung.contact.main.billing.street_number : '',
		plzbilling: 			bestellung.contact.main.billing ? bestellung.contact.main.billing.plz : '',
		citybilling: 			bestellung.contact.main.billing ? bestellung.contact.main.billing.city : '',
		emailbilling: 			bestellung.contact.main.billing ? bestellung.contact.main.billing.email : '',
		phonebilling: 			bestellung.contact.main.billing ? bestellung.contact.main.billing.phone : '',
		birthday: 				bestellung.contact.main.birthday ? bestellung.contact.main.birthday : '',
	}

	

	bestellung.anzahlLieferstellen > 1 && Object.entries(bestellung.lieferstellen).map(([key, value], index) => {
		initialValues['first_' + key] = bestellung.contact[key].first ? bestellung.contact[key].first : ''
		initialValues['last_' + key] = bestellung.contact[key].last ? bestellung.contact[key].last : ''
		initialValues['street_' + key] = bestellung.contact[key].street ? bestellung.contact[key].street : ''
		initialValues['street_number_' + key] = bestellung.contact[key].street_number ? bestellung.contact[key].street_number : ''
		initialValues['city_' + key] = bestellung.contact[key].city ? bestellung.contact[key].city : ''
		initialValues['company_' + key] = bestellung.contact[key].company ? bestellung.contact[key].company : ''
		initialValues['phone_' + key] = bestellung.contact[key].phone ? bestellung.contact[key].phone : ''
		initialValues['clientId_' + key] = bestellung.contact[key].clientId ? bestellung.contact[key].clientId : ''
		initialValues['email_' + key] = bestellung.contact[key].email ? bestellung.contact[key].email : ''
		initialValues['payment_' + key] = bestellung.contact[key].payment.method ? bestellung.contact[key].payment.method : ''
		initialValues['billing_' + key] = bestellung.contact[key].billing ? bestellung.contact[key].billing.billing : ''
		initialValues['firstbilling_' + key] = bestellung.contact[key].billing ? bestellung.contact[key].billing.first : ''
		initialValues['lastbilling_' + key] = bestellung.contact[key].billing ? bestellung.contact[key].billing.last : ''
		initialValues['companybilling_' + key] = bestellung.contact[key].billing ? bestellung.contact[key].billing.company : ''
		initialValues['streetbilling_' + key] = bestellung.contact[key].billing ? bestellung.contact[key].billing.street : ''
		initialValues['street_numberbilling_' + key] = bestellung.contact[key].billing ? bestellung.contact[key].billing.street_number : ''
		initialValues['plzbilling_' + key] = bestellung.contact[key].billing ? bestellung.contact[key].billing.plz : ''
		initialValues['citybilling_' + key] = bestellung.contact[key].billing ? bestellung.contact[key].billing.city : ''
		initialValues['emailbilling_' + key] = bestellung.contact[key].billing ? bestellung.contact[key].billing.email : ''
		initialValues['phonebilling_' + key] = bestellung.contact[key].billing ? bestellung.contact[key].billing.phone : ''
		initialValues['birthday' + key] = bestellung.contact[key].birthday ? bestellung.contact[key].birthday : ''
		return key
	})

	return (
		<Formik
			initialValues={initialValues}

		validate={values => {
			const errors = {}
			
			if (!values.first) { 
				errors.first = "Bitte Vornamen angeben"
			}
			if (!values.last) { 
				errors.last = "Bitte Nachnamen angeben"
			}
			else if (!values.street) { 
				errors.street = "Bitte Straße angeben"
			}
			else if (!values.street_number) { 
				errors.street_number = "Bitte Straße angeben"
			}
			else if (!values.city) { 
				errors.city = "Bitte Ort angeben"
			}
			else if (!values.email) {
				errors.email = "Bitte E-Mail Adresse eingeben"
			}
			else if (!values.phone) {
				errors.phone = "Bitte Telefonnummer eingeben"
			}
			else if (values.clientId !== "") {
				if ((values.clientId.length < 5 || values.clientId.length > 6) || isNaN(values.clientId)) { 
					errors.clientId = "Bitte gültige Kundennummer eingeben"
				}
			}
			else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
				errors.email = "Ungültige E-Mail Adresse"
			}
			else if (!bestellung.contact.main.payment.method) { 
				errors.payment = "Bitte Zahlmethode angeben"
			}

			else if (bestellung.anzahlLieferstellen > 1) {
				Object.entries(bestellung.lieferstellen).map(([key, value], index) => {
					if (!values[`first_${key}`]) { 
						errors[`first_${key}`] = "Bitte Vornamen angeben"
					}
					if (!values[`last_${key}`]) { 
						errors[`last_${key}`] = "Bitte Nachnamen angeben"
					}
					else if (!values[`street_${key}`]) { 
						errors[`street_${key}`] = "Bitte Straße angeben"
					}
					else if (!values[`street_number_${key}`]) { 
						errors[`street_number_${key}`] = "Bitte Straße angeben"
					}
					else if (!values[`city_${key}`]) { 
						errors[`city_${key}`] = "Bitte Ort angeben"
					}
					else if (!bestellung.contact[key].payment.method) { 
						errors[`payment_${key}`] = "Bitte Zahlmethode angeben"
					}
					else if (!values[`phone_${key}`]) { 
						errors[`phone_${key}`] = "Bitte Telefonnummer angeben"
					}
					else if (values[`clientId_${key}`] !== "") {
						if ((values[`clientId_${key}`].length < 5 || values[`clientId_${key}`].length > 6) || isNaN(values[`clientId_${key}`])) {
							errors[`clientId_${key}`] = "Bitte gültige Kundennummer eingeben"							
						}
					}
					else if (!values[`email_${key}`]) {
						errors[`email_${key}`] = "Bitte E-Mail Adresse eingeben"
					}
					else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values[`email_${key}`])) {
						errors[`email_${key}`] = "Ungültige E-Mail Adresse"
					}
					return key
				})
			}
			return errors

		}}
			
			onSubmit={(values, { setSubmitting }) => {
				
				console.log("===SUBMITTING===");

				

				let contact = {
					main: {
						...bestellung.contact.main,
						plz: bestellung.plz,
						first: values.first,
						last: values.last,
						email: values.email,
						street: values.street,
						street_number: values.street_number,
						city: values.city,
						company: values.company,
						phone: values.phone,
						clientId: values.clientId,
						birthday: clientChange.main.date,
						billing: {
							billing: billing,
							first: values.firstbilling || '',
							last: values.lastbilling || '',
							company: values.companybilling || '',
							street: values.streetbilling || '',
							street_number: values.street_numberbilling || '',
							city: values.citybilling || '',
							plz: values.plzbilling || '',
							email: values.emailbilling || '',
							phone: values.phonebilling || '',
						}
					},
				}

			
				
				bestellung.anzahlLieferstellen > 1 && Object.entries(bestellung.lieferstellen).map(([key, val], index) => {
					
					contact[key] = {
						...bestellung.contact[key],
						first: values[`first_${key}`],
						last: values[`last_${key}`],
						email: values[`email_${key}`],
						street: values[`street_${key}`],
						street_number: values[`street_number_${key}`],
						city: values[`city_${key}`],
						company: values[`company_${key}`],
						phone: values[`phone_${key}`],
						clientId: values[`clientId_${key}`],
						plz: val.plz,
						birthday: clientChange[key] ? clientChange[key].date : "",
						billing: {
							billing: bestellung.contact[key].billing.billing,
							first: values[`firstbilling_${key}`] || '',
							last: values[`lastbilling_${key}`] || '',
							company: values[`companybilling_${key}`]|| '',
							street: values[`streetbilling_${key}`] || '',
							street_number: values[`street_numberbilling_${key}`] || '',
							city: values[`citybilling_${key}`]|| '',
							plz: values[`plzbilling_${key}`] || '',
							email: values[`emailbilling_${key}`] || '',
							phone: values[`phonebilling_${key}`]|| '',
						},
						payment: {
							method: bestellung.contact[key].payment.method ? bestellung.contact[key].payment.method : '',
							price: bestellung.contact[key].payment.price ? bestellung.contact[key].payment.price : 0,
							clientId: bestellung.contact[key].payment.clientId ? bestellung.contact[key].payment.clientId : false,
						}
					}
					

					return key

				})


				setTimeout(() => {setBestellung(prev => ({
					...prev,
					contact
				}))
					setSubmitting(false)
					
					props.next()
				}, 400
					
				)
	
		}}
	>
		 {({ isSubmitting }) => (

				<Form className="no__bestellformular">
					
					<h3>Ihre persönlichen Angaben (PLZ {bestellung.plz})</h3>

					<div className="no__inputsection">

						<div className="no__input-group">
							<label htmlFor="first">Vorname*</label>
							<Field type="text" name="first"/>
							<ErrorMessage name="first" component="div" />
						</div>
						
						<div className="no__input-group">
							<label htmlFor="last">Nachname*</label>
							<Field type="text" name="last" />
							<ErrorMessage name="last" component="div" />
						</div>

						<div className="no__input-group">
							<label htmlFor="street">Straße*</label>
							<Field type="text" name="street" />
							<ErrorMessage name="street" component="div" />
						</div>

						<div className="no__input-group">
							<label htmlFor="street_number">Hausnummer*</label>
							<Field type="text" name="street_number" />
							<ErrorMessage name="street_number" component="div" />
						</div>

						<div className="no__input-group">
							<label htmlFor="city">Ort*</label>
							<Field type="text" name="city" />
							<ErrorMessage name="city" component="div" />
						</div>

						<div className="no__input-group">
							<label htmlFor="plz">PLZ*</label>
							<Field type="text" name="plz" required disabled value={bestellung.plz}/>
							<ErrorMessage name="plz" component="div" />
						</div>

						<div className="no__input-group">
							<label htmlFor="company">Firma</label>
							<Field type="text" name="company"/>
							<ErrorMessage name="company" component="div" />
						</div>

						<div className="no__input-group">
							<label htmlFor="email">E-Mail*</label>
							<Field type="email" name="email"/>
							<ErrorMessage name="email" component="div" />
						</div>

						<div className="no__input-group">
							<label htmlFor="phone">Telefon*</label>
							<Field type="text" name="phone" required/>
							<ErrorMessage name="phone" component="div" />
						</div>

					</div>

					<Payment
						handleUpdate={props.handleUpdate}
						bestellung={bestellung}
						settings={props.settings}
						region={props.region}
						client='main'
						active={bestellung.contact.main.payment.method}
					/>
					<ErrorMessage name="payment" component="div"/>

					<div className="no__inputsection">

						

						<div className="no__input-group">
						{bestellung.contact.main.payment.clientId ?
								<>
									<label htmlFor="clientId">Kundennummer*</label>
									<Field type="text" name="clientId" required onBlur={e => e.target.value !== "" ? handleClientChange('main', true) : handleClientChange('main', false)} />
								</>
									:
								<>
									<label htmlFor="clientId">Kundennummer</label>
									<Field type="text" name="clientId" onBlur={e => e.target.value !== "" ? handleClientChange('main', true) : handleClientChange('main', false)} />
								</>
						}
								<ErrorMessage name="clientId" component="div" />
							</div>

							<BirthdayPicker
								required={clientChange.main.required}
								client='main'
								data={clientChange}
								handleUpdate={setClientChange}
							/>
			
							
					</div>
						<Radio
							className="no__alternatebilling"
							required={false}
							name="billing"
							selected={billing}
							type="checkbox"
							handleChange={() => setBilling(!billing)}
							options={[{label: "Abweichende Rechnungsadresse", value: true}]}
						/>
						{billing && 						
							<>
									<h3 style={{marginTop: "20px"}}>Abweichende Rechnungsadresse</h3>
									<div className="no__inputsection">							
							
									<div className="no__input-group">
										<label htmlFor="first">Vorname*</label>
										<Field type="text" name="firstbilling"/>
										<ErrorMessage name="firstbilling" component="div" />
									</div>
									
									<div className="no__input-group">
										<label htmlFor="lastbilling">Nachname*</label>
										<Field type="text" name="lastbilling" />
										<ErrorMessage name="lastbilling" component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor="streetbilling">Straße*</label>
										<Field type="text" name="streetbilling" />
										<ErrorMessage name="street" component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor="street_numberbilling">Hausnummer*</label>
										<Field type="text" name="street_numberbilling" />
										<ErrorMessage name="street_numberbilling" component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor="citybilling">Ort*</label>
										<Field type="text" name="citybilling" />
										<ErrorMessage name="citybilling" component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor="plzbilling">PLZ*</label>
										<Field type="text" name="plzbilling" required/>
										<ErrorMessage name="plzbilling" component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor="companybilling">Firma</label>
										<Field type="text" name="companybilling"/>
										<ErrorMessage name="companybilling" component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor="emailbilling">E-Mail</label>
										<Field type="email" name="emailbilling"/>
										<ErrorMessage name="emailbilling" component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor="phonebilling">Telefon*</label>
										<Field type="text" name="phonebilling" required/>
										<ErrorMessage name="phonebilling" component="div" />
									</div>
								</div>
							</>
						}

					{bestellung.anzahlLieferstellen > 1 && Object.entries(bestellung.lieferstellen).map(([key, value], index) => {
						return (
						<div className="no__lieferstelle" key={key}>
							<h3>Lieferstelle {index + 2} ({value.plz})</h3>
							<div className="no__inputsection">
								<div className="no__input-group">
									<label htmlFor={`first_${key}`}>Vorname*</label>
									<Field type="text" name={`first_${key}`} />
									<ErrorMessage name={`first_${key}`} component="div" />
								</div>
							
								<div className="no__input-group">
									<label htmlFor={`last_${key}`}>Nachname*</label>
									<Field type="text" name={`last_${key}`} />
									<ErrorMessage name={`last_${key}`} component="div" />
								</div>
								<div className="no__input-group">
									<label htmlFor={`street_${key}`}>Straße*</label>
									<Field type="text" name={`street_${key}`} />
									<ErrorMessage name={`street_${key}`} component="div" />
								</div>
								<div className="no__input-group">
									<label htmlFor={`street_number_${key}`}>Hausnummer*</label>
									<Field type="text" name={`street_number_${key}`} />
									<ErrorMessage name={`street_number_${key}`} component="div" />
								</div>
								<div className="no__input-group">
									<label htmlFor={`city_${key}`}>Ort*</label>
									<Field type="text" name={`city_${key}`} />
									<ErrorMessage name={`city_${key}`} component="div" />
								</div>
								<div className="no__input-group">
									<label htmlFor={`plz_${key}`}>PLZ*</label>
									<Field type="text" name={`plz_${key}`} required disabled value={value.plz} />
									<ErrorMessage name={`plz_${key}`} component="div" />
								</div>
								<div className="no__input-group">
									<label htmlFor={`company_${key}`}>Firma</label>
									<Field type="text" name={`company_${key}`} />
									<ErrorMessage name={`company_${key}`} component="div" />
								</div>
								<div className="no__input-group">
									<label htmlFor={`email_${key}`}>E-Mail*</label>
									<Field type={`email_${key}`} name={`email_${key}`}/>
									<ErrorMessage name={`email_${key}`} component="div" />
								</div>
								<div className="no__input-group">
									<label htmlFor={`phone_${key}`}>Telefon*</label>
									<Field type="text" name={`phone_${key}`} required/>
									<ErrorMessage name={`phone_${key}`} component="div" />
								</div>
							
							</div>
							
							<Payment
								handleUpdate={props.handleUpdate}
								bestellung={bestellung}
								settings={props.settings}
								region={props.region}
								client={key}
								active={bestellung.contact[key] ? bestellung.contact[key].payment.method : ''}
							/>
								<ErrorMessage className="no__alert" name={`payment_${key}`} component="div" />
								<div className="no__inputsection">
							
								{bestellung.contact[key] && bestellung.contact[key].payment.clientId ?
										<div className="no__input-group">
											<label htmlFor={`clientId_${key}`}>Kundennummer</label>
											<Field type="text" name={`clientId_${key}`} required onBlur={ e => e.target.value !== "" ? handleClientChange(key, true) : handleClientChange(key, false)} />
											<ErrorMessage name={`clientId_${key}`} component="div" />
										</div>							
									:
										<div className="no__input-group">
											<label htmlFor={`clientId_${key}`}>Kundennummer</label>
											<Field type="text" name={`clientId_${key}`} onBlur={ e => e.target.value !== "" ? handleClientChange(key, true) : handleClientChange(key, false)} />
											<ErrorMessage name={`clientId_${key}`} component="div" />
										</div>							
								}
								<BirthdayPicker
									required={clientChange[key] ? clientChange[key].required : false}
									client={key}
									data={clientChange}
									handleUpdate={setClientChange}
									/>
									</div>
								<Radio
									className="no__alternatebilling"
									required={false}
									name={`billing_${key}`}
									selected={bestellung.contact[key].billing ? bestellung.contact[key].billing.billing : false}
									type="checkbox"
									handleChange={() => handleAdditionalBilling(key)}
									options={[{label: "Abweichende Rechnungsadresse", value: true}]}
								/>
						{bestellung.contact[key].billing.billing && 						
							<>
									<h3 style={{marginTop: "20px"}}>Abweichende Rechnungsadresse</h3>
								<div className="no__inputsection">
									<div className="no__input-group">
										<label htmlFor="first">Vorname*</label>
										<Field type="text" name={`firstbilling_${key}`}/>
										<ErrorMessage name={`firstbilling_${key}`} component="div" />
									</div>
									
									<div className="no__input-group">
										<label htmlFor={`lastbilling_${key}`}>Nachname*</label>
										<Field type="text" name={`lastbilling_${key}`} />
										<ErrorMessage name={`lastbilling_${key}`} component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor={`streetbilling_${key}`}>Straße*</label>
										<Field type="text" name={`streetbilling_${key}`} />
										<ErrorMessage name={`streetbilling_${key}`} component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor={`street_numberbilling_${key}`}>Hausnummer*</label>
										<Field type="text" name={`street_numberbilling_${key}`} />
										<ErrorMessage name={`street_numberbilling_${key}`} component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor={`citybilling_${key}`}>Ort*</label>
										<Field type="text" name={`citybilling_${key}`} />
										<ErrorMessage name={`citybilling_${key}`} component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor={`plzbilling_${key}`}>PLZ*</label>
										<Field type="text" name={`plzbilling_${key}`} required/>
										<ErrorMessage name={`plzbilling_${key}`} component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor={`companybilling_${key}`}>Firma</label>
										<Field type="text" name={`companybilling_${key}`}/>
										<ErrorMessage name={`companybilling_${key}`} component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor={`emailbilling_${key}`}>E-Mail</label>
										<Field type="email" name={`emailbilling_${key}`}/>
										<ErrorMessage name={`emailbilling_${key}`} component="div" />
									</div>
									<div className="no__input-group">
										<label htmlFor={`phonebilling_${key}`}>Telefon</label>
										<Field type="text" name={`phonebilling_${key}`}/>
										<ErrorMessage name={`phonebilling_${key}`} component="div" />
									</div>
								</div>
							</>
						}
							</div>
							
						)

					})}

					{/* <button type="submit" className="no__primary fixed__button" disabled={isSubmitting}>Bestellung prüfen</button> */}
					{/* <PrevNext
						setStep={props.setStep}
						step={props.step}
						disabled={isSubmitting}
					/> */}
						<div className="no__nav-buttons">
							{step > 1 && <div onClick={() => setStep(prev => prev - 1)} className="no__primary fixed__button back__button" >Zurück</div>}
							<Button type="submit" disabled={isSubmitting} title="Weiter" className="no__primary fixed__button" />
						</div>

			</Form>

			)}

	</Formik>
	)
}

export default PaymentScreen
